var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.showPopup
      ? _c(
          "div",
          {
            staticClass: "popup-overlay",
            on: {
              click: function($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.closePopup($event)
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "popup-content" },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      "margin-bottom": "10px"
                    }
                  },
                  [
                    _c("h6", [
                      _vm._v(
                        _vm._s(
                          _vm.$resourceString[
                            "product.Detail.Heading.DyelotInfo"
                          ]
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "popup-close-button",
                        on: { click: _vm.closePopup }
                      },
                      [
                        _c("span", {
                          staticClass:
                            "png-icon png-icon-icons-symbols--k-txtclose"
                        })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dyelot-container" }, [
                  _c("div", { staticClass: "dyelot-header" }, [
                    _c("p", [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.$resourceString["product.Detail.Title.Dyelot"]
                          )
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "qty-header" }, [
                    _c("p", [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.$resourceString[
                              "product.Detail.Label.AvailableQty"
                            ]
                          )
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm._l(_vm.dyelotObjects, function(dyelotObject) {
                  return _c(
                    "div",
                    {
                      key: dyelotObject.dyeLot,
                      staticClass: "dyelot-container"
                    },
                    [
                      _c("div", { staticClass: "dyelot-info" }, [
                        _c("p", [_vm._v(_vm._s(dyelotObject.dyeLot))])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "qty-info" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(dyelotObject.availQty) +
                              " " +
                              _vm._s(dyelotObject.uom)
                          )
                        ])
                      ])
                    ]
                  )
                }),
                _vm._v(" "),
                _c("div", [
                  _c("p", { staticClass: "text-success dye-lot-info-notice" }, [
                    _vm._v(
                      "\n                  " +
                        _vm._s(
                          _vm.$resourceString["product.Detail.Label.DyelotInfo"]
                        ) +
                        "\n                "
                    )
                  ])
                ])
              ],
              2
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }